/**
 * Homepage Scroll Links
 * Intercepts menu links on homepage to smooth scroll to sections instead of navigating
 */
(function() {
  'use strict';

  // Only run on homepage
  if (window.location.pathname !== '/' && window.location.pathname !== '/index' && !document.body.classList.contains('template-index')) {
    return;
  }

  // Map of page URLs to section selectors on homepage
  // Uses multiple fallback selectors to find the target section
  const scrollTargets = {
    '/pages/monthly-horoscope1': '#zodiac-grid, [id*="shopify-section-zodiac_grid"], .zodiac-grid-section',
    '/pages/horoscope-20261': '[id*="shopify-section-zodiac_circle"], .zc-banner'
  };

  // Find the first matching element from a selector list
  function findSection(selectorList) {
    const selectors = selectorList.split(', ');
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
    }
    return null;
  }

  // Easing function for smooth animation
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  // Custom smooth scroll with configurable duration
  function smoothScrollTo(element) {
    const headerOffset = 100; // Account for fixed header
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    const startPosition = window.pageYOffset;
    const distance = offsetPosition - startPosition;
    const duration = 1200; // Scroll duration in ms (slower)
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const easeProgress = easeInOutCubic(progress);

      window.scrollTo(0, startPosition + (distance + 90) * easeProgress);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }

  // Handle click on menu links
  function handleMenuClick(event) {
    const link = event.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Handle any hash link on the page (hero banner, image-with-text buttons, etc.)
    if (href.startsWith('#')) {
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        event.preventDefault();
        smoothScrollTo(targetElement);
      }
      return;
    }

    // Only handle page links from navigation menu
    const isInNav = link.closest('header, nav, .header, .menu-drawer, [class*="header"], [class*="nav"]');
    if (!isInNav) return;

    // Check if this link should scroll to a section
    for (const [pageUrl, sectionSelector] of Object.entries(scrollTargets)) {
      if (href === pageUrl || href.endsWith(pageUrl)) {
        const section = findSection(sectionSelector);
        if (section) {
          event.preventDefault();
          smoothScrollTo(section);

          // Close mobile menu if open by triggering click on summary
          const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container[open]');
          if (menuDrawerDetails) {
            const summary = menuDrawerDetails.querySelector('summary');
            if (summary) {
              summary.click();
            }
          }
          return;
        }
      }
    }
  }

  // Initialize when DOM is ready
  function init() {
    // Add click listener to document for menu links
    document.addEventListener('click', handleMenuClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
